import { createAsyncRequestTypes } from 'utils'
import { BASE_INFORM_API_URL } from 'services/constants'

export const SECURE_SEARCH = '@@SecureSearch/'
export const POPULATE_FIELD = `${SECURE_SEARCH}POPULATE_FIELD`
export const BLUR = `${SECURE_SEARCH}BLUR`
export const FOCUS = `${SECURE_SEARCH}FOCUS`
export const CLOSE_SEARCH = `${SECURE_SEARCH}CLOSE_SEARCH`
export const EXACT_MATCH_SEARCH = createAsyncRequestTypes(
  `${SECURE_SEARCH}EXACT_MATCH_SEARCH`
)
export const PARTIAL_MATCH_SEARCH = createAsyncRequestTypes(
  `${SECURE_SEARCH}PARTIAL_MATCH_SEARCH`
)
export const FIND_NEXT = createAsyncRequestTypes(`${SECURE_SEARCH}FIND_NEXT`)
export const FIND_PREV = createAsyncRequestTypes(`${SECURE_SEARCH}FIND_PREV`)
export const TOGGLE_FILTER = `${SECURE_SEARCH}TOGGLE_FILTER`
export const GET_TOOLTIP = createAsyncRequestTypes(
  `${SECURE_SEARCH}GET_TOOLTIP`
)
export const GET_SEARCH_FILTERS = createAsyncRequestTypes(
  `${SECURE_SEARCH}GET_SEARCH_FILTERS`
)

export const SECURE_PARTIAL_MATCH_SEARCH_URL = `${BASE_INFORM_API_URL}/search/securesearch/partialmatch`
export const SECURE_EXACT_MATCH_SEARCH_URL = `${BASE_INFORM_API_URL}/search/securesearch/exactmatch`

export const FIND_NEXT_SEARCH_URL = `${BASE_INFORM_API_URL}/search/findnext`
export const FIND_PREV_SEARCH_URL = `${BASE_INFORM_API_URL}/search/findprevious`
export const GET_TOOLTIP_URL = `${BASE_INFORM_API_URL}/search/indexsearch/summary`
export const GET_SEARCH_FILTER_URL = `${BASE_INFORM_API_URL}/search/indexsearch/filters`

export const OPEN_FILTERS_GRID = `${SECURE_SEARCH}OPEN_FILTERS_GRID`
export const CLOSE_FILTERS_GRID = `${SECURE_SEARCH}CLOSE_FILTERS_GRID`
export const CLEAR_FILTER_FIELD = `${SECURE_SEARCH}CLEAR_FILTER_FIELD`
export const SET_TEXT_FILTER_FIELD = `${SECURE_SEARCH}SET_TEXT_FILTER_FIELD`
export const RESET_FILTERS = `${SECURE_SEARCH}RESET_FILTERS`
export const CLEAR_SEARCH = `${SECURE_SEARCH}CLEAR_SEARCH`
